import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

const RuleBasedFilterPanel = ({ setFilters, setPage, setRowsPerPage }) => {
  const [rules, setRules] = useState(
    JSON.parse(localStorage.getItem("masterfilters")) || [{ field: "", condition: "", value: "" }]
  );

  const fields = [
    { label: "Lot Number", value: "Lot_Number" },
    { label: "Branch Name", value: "Branch_Name" },
    { label: "Farmer Name", value: "Farmer_Name" },
    { label: "Zone Name", value: "Zone_Name" },
    { label: "Vendor", value: "Vendor" },
    { label: "Shed Type", value: "Shed_Type" },
    { label: "Placed Quantity", value: "Placed_Qty" },
    { label: "CA", value: "CA" },
    { label: "Age(SAP)", value: "Age_SAP" },
    { label: "Diff", value: "Diff" },
    { label: "First Week Mortality", value: "first_Week_M" },
    { label: "First Week Mortality Percentage", value: "First_Week_Mortality_Percentage" },
    { label: "Mortality Quantity", value: "Total_Mortality" },
    { label: "Mortality Percentage", value: "Total_Mortality_Percentage" },
    { label: "Lifting EA", value: "Lifting_EA" },
    { label: "Lifting Percentage", value: "Lift_Percentage" },
    { label: "Balance Birds", value: "Bal_Birds" },
    { label: "FCR", value: "FCR" },
    { label: "Avg Body Weight", value: "ABWT" },
    { label: "BWT Age", value: "BWT_Age" },
    { label: "Feed Cons", value: "Feed_Cons" },
    { label: "Lifted Avg Weight", value: "Avg_Lift_Wt" },
    { label: "Prev Grade", value: "Prev_Grade" },
    { label: "Mobile Number", value: "Mobile" },
    { label: "Hatch Date", value: "Hatch_Date" },
    { label: "Line", value: "Line" },
    { label: "Hatchery Name", value: "Hatchery_Name" },
    { label: "Follow-up Date", value: "follow_up_date" },
  ];

  const conditions = [
    { label: "Contains", value: "contains" },
    { label: "Equals", value: "equal" },
    { label: "Greater Than", value: "greaterthan" },
    { label: "Greater Than or Equal", value: "greaterthanequal" },
    { label: "Less Than", value: "lessthan" },
    { label: "Less Than or Equal", value: "lessthanequal" },
  ];

  useEffect(() => {
    localStorage.setItem("filters", JSON.stringify(rules));
  }, [rules]);

  const handleAddRule = () => {
    setRules([...rules, { field: "", condition: "", value: "" }]);
  };

  const handleRemoveRule = (index) => {
    const newRules = [...rules];
    newRules.splice(index, 1);
    setRules(newRules);
  };

  const handleRuleChange = (index, key, value) => {
    const newRules = [...rules];
    newRules[index][key] = value;
    setRules(newRules);
  };

  const handleSearch = () => {
    console.log("Search with rules:", rules);
    setFilters(rules);
  };

  const handleClear = () => {
    const defaultRules = [{ field: "", condition: "", value: "" }];
    setRules(defaultRules);
    setFilters(defaultRules);
    setPage(0);
    setRowsPerPage(20);
    localStorage.removeItem("filters");
    localStorage.removeItem("page");
    localStorage.removeItem("rowsPerPage");
  };

  return (
    <Box>
      <Grid container spacing={2} style={{ marginBottom: 16 }}>
        {rules.map((rule, index) => (
          <Grid container item spacing={1} key={index}>
            <Grid item xs={12} sm={4}>
              <TextField
                select
                label="Field"
                value={rule.field}
                onChange={(e) =>
                  handleRuleChange(index, "field", e.target.value)
                }
                fullWidth
                size="small"
              >
                {fields.map((field) => (
                  <MenuItem key={field.value} value={field.value}>
                    {field.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                select
                label="Condition"
                value={rule.condition}
                onChange={(e) =>
                  handleRuleChange(index, "condition", e.target.value)
                }
                fullWidth
                size="small"
              >
                {conditions.map((condition) => (
                  <MenuItem key={condition.value} value={condition.value}>
                    {condition.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Value"
                value={rule.value}
                onChange={(e) =>
                  handleRuleChange(index, "value", e.target.value)
                }
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={1}>
              <IconButton
                onClick={() => handleRemoveRule(index)}
                color="secondary"
              >
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddRule}
            fullWidth
            startIcon={<AddIcon />}
          >
            Add Rule
          </Button>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSearch}
            fullWidth
          >
            Search
          </Button>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Button
            variant="outlined"
            
            onClick={handleClear}
            fullWidth
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RuleBasedFilterPanel;
